import { Fetch } from '.';
import { AppUser } from '../components/App/appReducer';

export interface SubType {
  id: number;
  description: string;
  isActive: boolean;
}
export const getDocumentSubtypes =
  (f: Fetch) =>
  async (
    contentTypeId: number,
    researchModelId: number
  ): Promise<SubType[]> => {
    const r = await f.graphQLFetch<SubType[]>(
      process.env.CPP_CONTENT_URI + '/researchModel',
      `{subTypes(contentTypeId: ${contentTypeId}, researchModelId:${researchModelId} ){
        id
        description
        isActive
            }
        }
      `
    );
    if (r) {
      let { subTypes } = r as any;
      return subTypes;
    }
    console.error('getDocumentSubtypes', r);
    throw new Error('Failed to getDocumentSubtypes');
  };

export const getSubtypeContextList =
  (f: Fetch) =>
  async (subTypeId: number): Promise<SubType[]> => {
    const r = await f.graphQLFetch<SubType[]>(
      process.env.CPP_CONTENT_URI + '/researchModel',
      `{subtypeContextList(subtypeId:${subTypeId}){
        id
        description
         }
        }
      `
    );
    if (r) {
      let { subtypeContextList } = r as any;
      return subtypeContextList;
    }
    console.error('getSubtypeContextList', r);
    throw new Error('Failed to getSubtypeContextList');
  };
